import React from 'react'
import { useHistory } from "react-router-dom";
import Container from '../../components/Container'
import Icon from '../../components/Icon'
import { HeadBarStyled, HeadBarContent, BackButton, Title, RightButtons, LeftButtons } from './styled'

const HeadBar = React.memo(({ children, title, noShadow, showBackButton, backTo }) => {
    const history = useHistory();

    const handleClickBackButton = () => {
        if(backTo) {
            history.push(backTo);
        } else {
            history.goBack();
        }
    }

    return (
        <HeadBarStyled noShadow={noShadow} >
            <Container>
                <HeadBarContent>
                    <LeftButtons>
                        {
                            showBackButton &&
                            <BackButton
                                onClick={handleClickBackButton}
                            >
                                <Icon name="back" />
                            </BackButton>
                        }
                    </LeftButtons>
                    <Title>
                        {title}
                    </Title>
                    <RightButtons>
                        {children}
                    </RightButtons>
                </HeadBarContent>
            </Container>
        </HeadBarStyled>
    )
})

HeadBar.defaultProps = {
    showBackButton: true
}

export default HeadBar
